// extracted by mini-css-extract-plugin
export default {"closeButton":"QGWdYEpABJG5UIPQkSMq AisLsJaE_AWnIhDlnTUV"};